import React from "react";
import {
    UserOutlined,
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    InfoCircleOutlined,
    TeamOutlined,
    BankOutlined,
    RocketOutlined
} from "@ant-design/icons";
import { Col, Row } from "antd";
import CommonCard from "../../../global/card";
import { cn } from "../../../../utils/cn";
import { formatDateTime, formatLeadSource } from "../../../../utils/functions";

const EnhancedLeadsSentDetails = ({
    leadDetail
}) => {
    if (!leadDetail) return null;

    const getIconForField = (label) => {
        const iconMap = {
            Name: <UserOutlined />,
            Email: <MailOutlined />,
            Phone: <PhoneOutlined />,
            "Event Date": <CalendarOutlined />,
            "Guest Count": <TeamOutlined />,
            Company: <BankOutlined />,
            "Imported At": <CalendarOutlined />,
            Source: <InfoCircleOutlined />,
            Destination: <RocketOutlined />
        };
        return iconMap[label] || <InfoCircleOutlined />;
    };

    const SectionHeader = ({ icon, title }) => (
        <div className="flex items-center gap-2 mb-3 sm:mb-4">
            {React.cloneElement(icon, { style: { color: "var(--primary-color, #1890ff)", fontSize: "clamp(14px, 4vw, 16px)" } })}
            <span style={{ fontSize: "clamp(13px, 4vw, 15px)", fontWeight: 600 }}>{title}</span>
        </div>
    );

    const InfoItem = ({ label, value, className }) => (
        <Col xs={24} sm={12}>
            <div className="flex flex-col">
                <span className="text-xs text-gray-500 flex items-center gap-2 mb-1">
                    <span style={{ color: "var(--primary-color, #1890ff)" }}>
                        {getIconForField(label)}
                    </span>
                    {label}
                </span>
                <span className={cn("text-sm font-semibold text-gray-900", className)}>{value || "—"}</span>
            </div>
        </Col>
    );

    const { LeadsInformation } = leadDetail;

    return (
        <div className="sm:p-6 p-2 w-full min-h-full overflow-x-hidden" style={{ backgroundColor: "#f5f7fa" }}>
            <CommonCard
                cardHeadBodyClassName={{ head: "!px-6 !py-0", body: "!px-6 !py-0 !pb-4" }}
                title={
                    <div className="flex items-center gap-2">
                        <UserOutlined style={{ color: "var(--primary-color, #1890ff)", fontSize: "clamp(16px, 5vw, 18px)" }} />
                        <span style={{ fontSize: "clamp(14px, 5vw, 16px)", fontWeight: 600 }}>Lead Details</span>
                    </div>
                }
            >
                <Row gutter={[24, 0]}>
                    {/* Basic Information Section */}
                    <Col span={24} className="py-4">
                        <SectionHeader icon={<UserOutlined />} title="Basic Information" />
                        <Row gutter={[{ xs: 16, sm: 24 }, { xs: 12, sm: 16 }]}>
                            <InfoItem
                                label="Name"
                                value={LeadsInformation?.fullName ? LeadsInformation.fullName : `${LeadsInformation?.firstName} ${LeadsInformation?.lastName}`}
                            />
                            <InfoItem label="Email" value={LeadsInformation?.email} />
                            <InfoItem label="Phone" value={LeadsInformation?.phone} />
                            <InfoItem label="Guest Count" value={LeadsInformation?.guestCount} />
                            <InfoItem label="Company" value={LeadsInformation?.company} />
                            <InfoItem label="Imported At" value={formatDateTime(LeadsInformation?.createdAt)} />
                            <InfoItem
                                label="Source"
                                value={formatLeadSource(LeadsInformation?.leadSource)}
                                className="capitalize"
                            />
                            <InfoItem
                                label="Destination"
                                value={leadDetail.destinationId}
                                className="capitalize"
                            />
                        </Row>
                    </Col>
                </Row>
            </CommonCard>
        </div>
    );
};

export default EnhancedLeadsSentDetails;
